module.exports = __webpack_public_path__ + "img/icon_suc.4d0c1b62.png";